import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useGetRookBlueprintUrlMutation } from '../../../features/authentication/rookBlueprintApiSlice';

const RookBlueprintAuthenticateModel  = () => {
  const [getRookBlueprintUrl] = useGetRookBlueprintUrlMutation();
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    authenticateAsync();
  }, []);

  const authenticateAsync = async () => {
    setIsAuthenticating(true);
    const response = await getRookBlueprintUrl();
    if (response.error) {
      if (response.error.data.errors)
        setError(response.error.data.errors.Error);
      else
        setError(response.error.data.error);
    } else {
      window.location.href = response.data.redirectUrl;
    }
    setIsAuthenticating(false);
  };

  return (
    <div className='white-card h-320'>
      <h5>Rook Blueprint</h5>
      {isAuthenticating &&
                <div className='scroll-spinner mt-5 d-flex fs-1 align-item-center justify-content-center'>
                  <FontAwesomeIcon icon={faSpinner} spin  /><span className='ms-3 fs-2'>Authenticating...</span>
                </div>
      }
      {error?.length > 0 &&
                <div className='text-danger mt-4 text-center'>{error}</div>
      }
    </div>
  );
};

export default RookBlueprintAuthenticateModel;
